import * as React from "react";
import {
    BooleanField,
    BooleanInput,
    Datagrid,
    DateField,
    Edit,
    EditButton,
    List,
    ListButton,
    RaRecord,
    Show,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput,
    TopToolbar,
    useRecordContext
} from "react-admin";
import { SaveToolbar } from "../customComponents/CustomToolbars";
import { EditViewActions } from "../customComponents/CustomTopToolbars";
import { dateTimeOptionsDeCH, Props2String, viewRedirect } from "./Common";

export const RescueVehiclesResource = "rescuevehicles";

export const RescueVehicleList = () => (
    <List perPage={25} exporter={false}>
        <Datagrid bulkActionButtons={false}
                  rowClick={viewRedirect.edit}
                  rowStyle={() => ({height: "2.25rem"})}>
            <TextField source={RescueVehicleProps.name}/>
            <BooleanField source={RescueVehicleProps.isActive}/>
            <EditButton
                label=""
                sx={{
                    padding: "0px",
                    verticalAlign: "inherit",
                    minWidth: 0
                }}
            />
        </Datagrid>
    </List>
);

const RescueVehicleShowViewActions = () => {
    const record = useRecordContext();
    return (
        <TopToolbar>
            {record?.isActive && <EditButton/>}
            <ListButton/>
        </TopToolbar>
    );
};

export const RescueVehicleShow = () => (
    <Show actions={<RescueVehicleShowViewActions/>}>
        <SimpleShowLayout>
            <RescueVehicleShowFields/>
        </SimpleShowLayout>
    </Show>
);

export const RescueVehicleShowFields = () => (
    <>
        <TextField source={RescueVehicleProps.name}/>
        <BooleanField source={RescueVehicleProps.isActive}/>
        <TextField source={RescueVehicleProps.crewQualifications}/>
        <DateField source={RescueVehicleProps.createdAt} showTime locales="de-CH" options={dateTimeOptionsDeCH}/>
        <DateField source={RescueVehicleProps.lastModified} showTime locales="de-CH" options={dateTimeOptionsDeCH}/>
    </>
);

export const RescueVehicleEdit = () => (
    <Edit actions={<EditViewActions/>} redirect={viewRedirect.list}>
        <SimpleForm warnWhenUnsavedChanges toolbar={<SaveToolbar/>}>
            <RescueVehicleFormFields/>
        </SimpleForm>
    </Edit>
);

export const RescueVehicleFormFields = () => (
    <>
        <TextField source={RescueVehicleProps.name}/>
        <BooleanInput source={RescueVehicleProps.isActive}/>
        <TextInput source={RescueVehicleProps.crewQualifications}/>
    </>
);

export type RescueVehicle = RaRecord & {
    id: number,
    name: string,
    isActive: boolean,
    crewQualifications?: string | null,
    createdAt: number,
    lastModified: number
};

export const RescueVehicleProps: Props2String<RescueVehicle> = {
    id: "id",
    name: "name",
    isActive: "isActive",
    crewQualifications: "crewQualifications",
    createdAt: "createdAt",
    lastModified: "lastModified"
};
